import { SavedSearch, SavedSearchPage } from '@creditsights/api-ui-web';
import { TableViewConfig } from '@creditsights/styleguide-web';
import { createSearchParams } from 'react-router-dom';
import { ActionCellRenderer, DateRenderer } from '../../../components/formatters';
import CheckboxCellRenderer, {
  CheckboxCellRendererProps,
} from '../../../components/formatters/CheckboxCellRenderer/CheckboxCellRenderer';
import { getUrlSearchParams } from '../../SearchResults/SearchResults.logic';
import FiltersRenderer from './CellRenderers/FiltersRenderer/FiltersRenderer';
import { SearchesTabCellTextRenderer } from './CellRenderers/SearchesTabCellTextRenderer';
import { EDIT_BUTTON_TOOLTIP } from './SearchesTab.constants';

export const searchesColumnsConfig = (
  cellClassname: string,
  checkboxCellProps: CheckboxCellRendererProps,
  onEdit: (index: number, item: SavedSearch) => void
): TableViewConfig => ({
  columns: [
    {
      dataKey: 'deleteCheckbox',
      width: '2.8rem',
      cellDataRenderer: CheckboxCellRenderer,
      headerCellRenderer: CheckboxCellRenderer,
      cellRendererProps: checkboxCellProps,
    },
    {
      cellClassname,
      cellDataRenderer: DateRenderer,
      dataKey: 'createdAt',
      headerName: 'Save Date',
    },
    {
      cellClassname,
      cellDataRenderer: SearchesTabCellTextRenderer,
      cellRendererProps: {
        link: (item: SavedSearch) =>
          item.pageName === SavedSearchPage.GlobalSearch
            ? createSearchParams(getUrlSearchParams(item)).toString()
            : null,
      },
      dataKey: 'name',
      headerName: 'Name',
      maxWidth: '20.6rem',
    },
    {
      cellClassname,
      cellDataRenderer: SearchesTabCellTextRenderer,
      cellRendererProps: { indicateEmptyValue: true },
      headerName: 'Search keywords',
      dataKey: 'keywords',
      maxWidth: '25.9rem',
    },
    {
      cellClassname,
      cellDataRenderer: SearchesTabCellTextRenderer,
      cellRendererProps: { defaultValue: 'Global Search' },
      dataKey: 'page',
      headerName: 'Page',
    },
    {
      dataKey: 'filters',
      headerName: 'Filters',
      cellDataRenderer: FiltersRenderer,
      maxWidth: '58.2rem',
    },
    {
      dataKey: '',
      cellDataRenderer: ActionCellRenderer,
      cellRendererProps: {
        onEdit,
        showEditAction: (item) => item.pageName === SavedSearchPage.GlobalSearch,
        editButtonTooltip: EDIT_BUTTON_TOOLTIP,
      },
      width: '4rem',
    },
  ],
});
